export class BinderInfo {
	binderName?: string = null;
	virtualBinderHashId: number;
}
